import DOMPurify from 'dompurify';

const RICH_TEXT_TAGS = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'b', 'i', 'u', 's', 'em', 'strong',
    'p', 'br', 'div', 'span', 'blockquote',
    'ul', 'ol', 'li',
    'a', 'img',
    'font', 'sub', 'sup', 'code', 'pre', 'hr',
    'svg', 'path', 'polyline', 'rect', 'circle',
];

const RICH_TEXT_ATTR = [
    'href', 'target', 'rel', 'title', 'src', 'alt', 'width', 'height',
    'class', 'style', 'contenteditable',
    'color', 'face', 'size', 'align',
    'data-rte-type', 'data-rte-key', 'data-rte-name', 'data-rte-src',
    'data-rte-url', 'data-rte-view-link', 'data-rte-action',
    'data-wrap-mode', 'data-rotate', 'data-flip-h', 'data-flip-v',
    'data-margin', 'data-recolor', 'data-opacity', 'data-brightness', 'data-contrast', 'data-blur',
    'xmlns', 'viewBox', 'fill', 'stroke', 'stroke-width', 'd', 'points',
];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export const sanitizeHtml = (html) => {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: RICH_TEXT_TAGS,
        ALLOWED_ATTR: RICH_TEXT_ATTR,
        ALLOW_DATA_ATTR: true,
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    });
};

export const richTextProps = (html) => ({
    __html: sanitizeHtml(html),
});
